import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";

const currentUser = {
  name: "Test Testsson",
  HSAid: "TGST871238123-238231",
  role: "Superanvändare",
  carePrincipal: "Region Jämtland Härjedalen",
  careUnit: "Kommun 2",
};

const roles = [
  "Läsanvändare",
  "Begränsad Användare",
  "Användare",
  "Administratör",
  "Superanvändare",
];

export function LoginTestUserModal() {
  const [loginForm, setLoginForm] = useState(currentUser);
  const dispatch = useDispatch();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    setLoginForm({
      ...loginForm,
      [event.target.name]: event.target.value,
    });
  };

  const handleSelectChange = (event: SelectChangeEvent) => {
    setLoginForm({
      ...loginForm,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();

    const carePrincipal = {
      name: loginForm.carePrincipal,
      id: "SE111-JLL",
    };

    const params = {
      name: loginForm.name,
      id: loginForm.HSAid,
      role: loginForm.role,
      carePrincipal: carePrincipal,
      careUnit: loginForm.careUnit,
    };
    dispatch({ type: "LOGIN_REQUEST", params });
  };

  return (
    <Dialog
      open={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Logga In</DialogTitle>
      <DialogContent>
        <Stack spacing={1}>
          <TextField
            size="small"
            autoFocus
            value={loginForm.name}
            onChange={handleChange}
            name="name"
            label="Namn"
          />
          <TextField
            size="small"
            autoFocus
            value={loginForm.HSAid}
            onChange={handleChange}
            name="HSAid"
            label="Korttyp"
          />
          <Select
            sx={{ width: "22ch", textAlign: "left" }}
            value={loginForm.role}
            onChange={handleSelectChange}
            name="role"
            size="small"
          >
            {roles.map((role: any) => (
              <MenuItem key={role} id={role} value={role}>
                {role}
              </MenuItem>
            ))}
          </Select>
          <TextField
            size="small"
            autoFocus
            value={loginForm.carePrincipal}
            onChange={handleChange}
            name="carePrincipal"
            label="Vårdhuvudman"
          />
          <TextField
            size="small"
            autoFocus
            value={loginForm.careUnit}
            onChange={handleChange}
            name="careUnit"
            label="Vårdenhet"
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => dispatch({ type: "MODAL_CANCEL" })}
        >
          Avbryt
        </Button>
        <Button variant="contained" onClick={handleSubmit}>
          Logga in
        </Button>
      </DialogActions>
    </Dialog>
  );
}
